import { Injectable } from "@angular/core";
@Injectable()
export class NotificationTransFormer {
    transform(notification) {
        return  {
            id: notification.id,
            timestamp: notification.postTimeStr,
            type: notification.messageType,
            content: notification.context,
            user: {
                id: notification.uid,
                name: notification.title,
                avatar: notification.headImage,
                role: this.getUserRoleFromImage(notification.userLevelPic),
            },
            video: {
                title: notification.videoName,
                key: notification.videoUrl,
            },
            comment: {
                id: notification.commentID,
                likes: notification.hit,
                floor: notification.louCeng,
                reply: {
                    title: notification.toTitle,
                    floor: notification.replyLouCeng,
                }
            },
            notificationId: notification.id
        };
    }

    getUserRoleFromImage(imagePath) {
        if (!imagePath) {
            return '';
        }
        switch (true) {
            case imagePath.indexOf('royal-vvvip.png') !== -1:
                return 'royalVip';
            case imagePath.indexOf('royal-admin.png') !== -1:
                return 'royalAdmin';
            case imagePath.indexOf('normal-vip.png') !== -1:
                return 'vip';
            case imagePath.indexOf('g-VIP.png') !== -1:
                return 'gvip';
            case imagePath.indexOf('et-VIP.png') !== -1:
                return 'etvip';
            case imagePath.indexOf('cpvip.png') !== -1:
                return 'cpvip';
            case imagePath.indexOf('editor.png') !== -1:
                return 'editor';
            default:
                return '';
        }
    }
}
